import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext'
import { useEffect } from 'react'
import { $getSelection, $isRangeSelection } from 'lexical'
import {
  INSERT_SOCIAL_EMBED_COMMAND,
  PROVIDERS,
  $createEmbedNode,
} from '../nodes/EmbedNode' // קו-ייבוא יחיד

export function EmbedPlugin() {
  const [editor] = useLexicalComposerContext()

  /* רישום הפקודה */ // :contentReference[oaicite:6]{index=6}
  useEffect(
    () =>
      editor.registerCommand(
        INSERT_SOCIAL_EMBED_COMMAND,
        ({ provider, src }) => {
          editor.update(() => {
            const sel = $getSelection()
            if (!$isRangeSelection(sel)) return false
            sel.insertNodes([$createEmbedNode(provider, src)])
          })
          return true
        },
        0
      ),
    [editor]
  )

  /* הדבקה אוטומטית של קישורים */
  useEffect(
    () =>
      editor.registerCommand(
        'CAN_USE_URL',
        (url) => {
          const match = Object.entries(PROVIDERS).find(([, { re }]) =>
            re.test(url)
          )
          if (!match) return false
          const [provider, { re, toSrc }] = match
          const idOrUrl = url.match(re)?.[1] || url
          editor.dispatchCommand(INSERT_SOCIAL_EMBED_COMMAND, {
            provider,
            src: toSrc(idOrUrl),
          })
          return true
        },
        1
      ),
    [editor]
  )

  return null
}
